module.exports = __webpack_public_path__ + "src/assets/img/cmdProg1.4742ea85.svg";